<template>
  <div>
    <div class="text-right">
      <b-button size="sm" class="btn btn-primary add-button mb-1" variant="primary" @click="()=>openNewModal()">
        <i class="fa-solid fa-plus"></i>
        {{ $t('Add CPA') }}
      </b-button>
    </div>
    <b-table
        v-if="affiliate.affiliateCpas!=null"
        ref="cpaTable"
        striped
        hover
        responsive
        v-bind:items="affiliate.affiliateCpas"
        v-bind:fields="fields"
        @row-clicked="openNewModal"
    >
      <template #cell(creationTime)="data">
        {{
          $moment(data.value)
              .format('DD/MM/YYYY HH:mm:ss')
        }}
      </template>

      <template #cell(cpa)="data">
        {{ convertToEURO(data.value) }}
      </template>


      <template #cell(actions)="row">
        <b-button size="sm" class="btn btn-danger"
                  @click="deleteOpen(row.item, row.index, $event.target)"
        >
          {{ $t('Delete') }}
        </b-button>
      </template>

    </b-table>
    <b-modal :id="deleteModal.id" centered :title="$t('Confirmation')"
             @ok="deleteCpaById(deleteModal.cpaId)" ok-variant="danger" :cancel-title="$t('operations.cancel')" @hide="resetInfoModal">
      <p class="my-4">{{ $t('areyousureyouwanttodeletethisexpenses') }}</p>
    </b-modal>
    <affiliate-c-p-a-modal ref="cpaModal" :affiliate-id="affiliateId"/>
  </div>
</template>

<script>
import Affiliate from '@/model/affiliate/Affiliate'
import mixinPermissions from '@/components/mixin/mixinPermissions'
import { mapActions, mapGetters } from 'vuex'
import mixinNotifications from '@/components/mixin/mixinNotifications'
import OrganizationSelectBox from '@/components/widget/select/OrganizationSelectBox'
import BusinessUnitSelectBox from '@/components/widget/select/BusinessUnitSelectBox'
import CountriesSelectBox from '@/components/widget/select/CountriesSelectBox'
import CalendarPicker from '@/components/widget/picker/calendarPicker'
import mixinBase from '@/components/mixin/mixinBase'
import AffiliateCPAModal from '@/components/modal/AffiliateCPAModal.vue'


export default {
  name: 'AffiliateEditCpa',
  components: {
    AffiliateCPAModal,
    CalendarPicker,
    CountriesSelectBox,
    BusinessUnitSelectBox,
    OrganizationSelectBox
  },
  mixins: [mixinPermissions, mixinNotifications, mixinBase],
  data: () => ({
    affiliate: Affiliate(),
    affiliateCpa: {},

    fields: [],
    deleteModal: {
      id: 'delete-modal',
      title: 'Delete Cpa entry',
      content: ''
    },
  }),
  props: {
    value: {
      required: true,
      default: () => ({})
    },
    newAffiliate: {
      type: Boolean,
      default: () => false
    }
  },
  watch: {
    value: {
      handler() {
        this.affiliate = Object.assign(Affiliate(), this.value)
      },
      immediate: true
    }
  },
  created() {
    this.setFields()
  },
  computed: {
    ...mapGetters('affiliate', ['']),
    affiliateId(){
      return this.affiliate?.id
    }
  },
  methods: {
    ...mapActions('affiliate', ['updateAffiliate', 'deleteCpa', 'createCpaAffiliate']),

    setFields() {
      let $this = this
      this.fields = [
        {
          key: 'creationTime',
          label: $this.$t('columns.creationTime'),
          sortable: true
        },

        {
          key: 'cpa',
          label: $this.$t('columns.cpa'),
          sortable: true
        },

        {
          key: 'crg',
          label: $this.$t('columns.crg'),
          sortable: true
        },
        {
          key: 'crgWeek',
          label: $this.$t('columns.crgWeek'),
          sortable: true
        },

        {
          key: 'actions',
          label: $this.$t('Actions'),
          sortable: true
        },
      ]
    },
    resetInfoModal() {
      this.$root.$emit('bv::hide::modal', this.deleteModal.id)
    },
    async deleteCpaById(cpaId) {
      let $this = this
      await this.deleteCpa({
        id: this.affiliate.id,
        cpaId: cpaId
      })
          .catch(err => {
            this.showErrorNotification(this.$t('globalMessages.fetchDataError', { system: this.$t('menu.affiliates') }), err.response.data.error)
          })
      this.showSuccessNotification($this.$t('globalMessages.updateDataSuccess', { system: $this.$t('menu.affiliates') }))
      this.$emit('input', this.affiliate)

    },
    deleteOpen(item, index, button) {
      this.deleteModal.title = `Row index: ${index}`
      this.deleteModal.cpaId = item.id
      this.$root.$emit('bv::show::modal', this.deleteModal.id, button)
    },
    openNewModal(item) {
      this.$refs.cpaModal.show(item)
    },
  }
}
</script>

<style scoped>
.table-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 1rem;
}

.add-button {
  margin-left: 1rem;
}
</style>
